import { CaretDown as ChevronDown } from "@phosphor-icons/react";
import type { SelectHTMLAttributes } from "react";
import { cn } from "@/lib/cn";

export function Select({ className, children, ...props }: SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <span className="relative inline-flex">
      <select
        className={cn(
          "h-9 appearance-none rounded-sm border border-border bg-surface-2 py-2 pr-8 pl-3 text-body text-text-primary focus-visible:outline-2 focus-visible:outline-primary",
          className,
        )}
        {...props}
      >
        {children}
      </select>
      <ChevronDown size={16} weight="regular" className="pointer-events-none absolute top-1/2 right-2.5 -translate-y-1/2 text-text-secondary" aria-hidden="true" />
    </span>
  );
}
